<!-- global-index -->
<section class="global-index-section">
  <p class="text-danger tw-mb-5 tw-mt-3 tw-mr-3 tw-font-semibold">
    <span class="mdi mdi-alert-circle-outline mdi-18px"></span>
    {{ "common.generalIndexes" | translate }}
  </p>
  <div class="tw-flex-center tw-mt-2 tw-px-4">
    <h6
      class="tw-w-1/4 tw-font-medium tw-text-gray-600 pb-5 dark:tw-text-gray-300"
    >
      {{ "common.generalIndexing" | translate }}
    </h6>
    <div class="tw-w-3/4">
      <div class="tw-flex">
        <form-field
          class="tw-px-1 tw-w-1/2"
          type="number"
          label="common.fromIndex"
          [min]="0"
          [classList]="'tw-text-lg dir-ltr'"
          [(value)]="globalFromIndex"
          (valueChange)="checkIsValidGlobalIndex()"
        >
        </form-field>
        <form-field
          class="tw-px-1 tw-w-1/2"
          type="number"
          label="common.count"
          [min]="0"
          [classList]="'tw-text-lg dir-ltr'"
          [(value)]="globalCount"
          (valueChange)="checkIsValidGlobalIndex()"
        >
        </form-field>
      </div>
    </div>
  </div>
</section>
